var _g, _circle, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_54871_1209)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.7051,
    r: 17.5,
    fill: "#0071FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 32.5,
    fill: "#0071FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54871_1209)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54871_1209",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 31,
    width: 40,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 31H30.9999V70H69.9999V31Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54871_1209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9794 46.1482C58.4837 45.1649 57.8823 44.2953 57.3054 43.4664C56.7933 42.735 56.3139 42.0361 55.8913 41.2559C55.3143 40.1994 55.0055 38.8586 54.6967 37.5664L54.5179 36.8268C54.3716 36.2417 54.3798 35.4453 54.3878 34.6652C54.396 33.5762 54.404 32.4547 54.0303 31.577C53.9084 31.2763 53.6158 31.0813 53.2907 31.0813L45.741 31H45.7329C45.2859 31 44.9202 31.3657 44.9202 31.8127C44.9202 31.9102 44.9364 31.9996 44.9689 32.089C45.3184 33.0561 45.1965 34.844 45.0908 36.2743C45.0583 36.77 45.0259 37.2332 45.0096 37.6314C44.9608 39.1673 44.3188 40.8821 43.0266 42.865C41.6695 44.9535 41.125 46.717 41.1493 48.9681C41.1575 49.9839 41.5313 50.8129 42.2383 51.3899C43.0754 52.0644 44.3837 52.3326 45.814 52.1457C45.684 52.2432 45.5459 52.3326 45.4077 52.422C45.2127 52.5439 44.9526 52.5765 44.6438 52.6171C44.1805 52.682 43.6036 52.7715 43.0509 53.1778C41.9132 54.023 41.905 55.0794 41.9863 56.0059C42.1082 57.3793 42.9128 58.5252 43.628 59.541C43.8962 59.9149 44.14 60.2724 44.3512 60.6219C45.3183 62.2635 45.5864 64.3195 45.8384 66.3106C45.9685 67.3264 46.1066 68.3667 46.326 69.3662C46.4073 69.7401 46.7405 70.0002 47.1224 70.0002H47.1712L53.5343 69.6263C53.9651 69.6019 54.2983 69.2443 54.2983 68.8136C54.2983 65.8555 54.8672 62.873 56.143 59.1428C56.2649 58.7853 56.4274 58.4196 56.5981 58.0458C57.1182 56.8674 57.7114 55.5346 57.232 53.9661C57.1101 53.5598 56.8744 53.2022 56.5412 52.934C57.1263 52.9422 57.7114 52.8203 58.2478 52.5927C58.906 52.292 59.4099 51.7312 59.6375 51.0405C60.2228 49.3745 59.467 47.1071 58.9794 46.1482ZM55.1111 57.4037C54.9323 57.8019 54.7536 58.2082 54.6073 58.6389C53.3801 62.2227 52.7707 65.1727 52.6813 68.0658L47.7809 68.3502C47.6508 67.635 47.5533 66.8956 47.4558 66.1235C47.1795 63.9699 46.8869 61.7432 45.7574 59.8172C45.5217 59.4109 45.2372 59.0126 44.9609 58.6226C44.3108 57.6961 43.6932 56.8266 43.6119 55.8838C43.5388 55.0711 43.62 54.803 44.0264 54.5023C44.2376 54.3479 44.4814 54.3073 44.8796 54.2504C45.2941 54.1935 45.7655 54.1203 46.2449 53.8359C46.6106 53.6084 46.952 53.3565 47.2852 53.0801C47.8621 52.6169 48.3091 52.2512 48.9592 52.1699C49.1299 52.1455 49.3005 52.1374 49.4793 52.1374C49.8776 52.1374 50.2189 52.2023 50.4302 52.3243C50.6414 52.4462 50.8446 52.5843 51.0397 52.7225C51.4297 52.9907 51.8686 53.2995 52.4212 53.5027C52.8438 53.6571 53.3232 53.7059 53.8352 53.7709C54.8266 53.8846 55.5418 54.0065 55.68 54.4617C55.9806 55.4451 55.5825 56.3553 55.1111 57.4037ZM58.1017 50.4959C58.0205 50.7641 57.8335 50.9917 57.5735 51.1054C56.3708 51.6499 54.3228 50.9591 52.9657 50.4959L52.4375 50.3171C51.4135 49.9676 50.3408 49.797 49.2599 49.8133C48.3497 49.8133 47.6671 50.0083 47.0088 50.2034C46.7081 50.2927 46.3912 50.3822 46.0336 50.4553C44.904 50.691 43.8069 50.561 43.2624 50.114C42.9373 49.854 42.7829 49.472 42.7748 48.9437C42.7586 47.0177 43.2137 45.5549 44.3921 43.7346C45.8467 41.4916 46.5781 39.5086 46.635 37.6639C46.6512 37.282 46.6756 36.835 46.7082 36.3636C46.7975 35.1202 46.895 33.7631 46.7407 32.6091L52.665 32.6822C52.7626 33.2348 52.7626 33.95 52.7544 34.6408C52.7463 35.5103 52.7463 36.4124 52.9332 37.1925L53.1039 37.9158C53.429 39.3136 53.7703 40.7521 54.4448 42.0035C54.908 42.865 55.4444 43.6288 55.9564 44.3684C56.5253 45.1891 57.0697 45.9693 57.5086 46.8551C57.9798 47.7816 58.4593 49.4964 58.1017 50.4959Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_54871_1209",
    x: 0,
    y: 0.205078,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_54871_1209"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54871_1209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(31 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnee);
export default __webpack_public_path__ + "static/media/knee.9fc214cb7889c42001663b28c1e30708.svg";
export { ForwardRef as ReactComponent };